import Tippy from '@tippyjs/react';

import { Alert } from 'components/shared/Alert/Alert';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import PayrocAchPayment from 'components/Payments/payroc/PayrocAchPayment';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

const NewACH = ({ amount, hideButton, buttonText, fieldRows, onError, onLoadError }) => {
  const { handlePayment, setFieldValue } = usePaymentContextApi();
  const { values, terminalPin, forceSaveCard } = usePaymentContext();

  const isRecurringPayment = Boolean(values.recurringPayment);
  const isSaveCard = forceSaveCard || values.saveCard || isRecurringPayment;
  const isSaveCardDisabled = isRecurringPayment || forceSaveCard;

  const handleAchPayment = (data) => handlePayment({ ...data, type: 'ach' });

  return (
    <PayrocAchPayment
      key="pay-with-new-ach"
      id="pay-with-new-ach"
      amount={amount}
      handlePayment={handleAchPayment}
      terminalPin={terminalPin}
      hideButton={hideButton}
      buttonText={buttonText}
      fieldRows={fieldRows}
      onError={onError}
      onLoadError={onLoadError}>
      <div className="flex w-full flex-col gap-3 self-start">
        {!isSaveCardDisabled ? (
          <Tippy
            content="This bank account will be saved for future payments"
            className="tippy-dark">
            <Checkbox
              size={20}
              isChecked={isSaveCard}
              disabled={isSaveCardDisabled}
              onChange={(event) => setFieldValue('saveCard', event.target.checked)}
              className="max-w-[456px]"
              innerLabelClassName="items-start"
              labelClassName="font-medium"
              label="Save this bank account for future charges"
            />
          </Tippy>
        ) : (
          <Alert
            message="This bank account will be saved for future payments"
            variant="lighter"
            color="primary"
            className="w-full"
          />
        )}
      </div>
    </PayrocAchPayment>
  );
};

export default NewACH;
